(function ($, Drupal, drupalSettings) {
  'use strict';

  Theme.all = function (common, options) {
    // Inheritance
    this.common = common;

    // Selectors
    this.selectors = {
      // EXAMPLES: Data, Hover, Focus...
    };

    // Elements
    this.elements = {
      html: $('html'),
      body: $('body'),
      blockGalery: $('.paragraph--type--block-galery .galery--content'),
      blockInspirationsWall : $('.block-inspirations--wall'),
      blockSlider: $('.paragraph--type--block-slider'),
      blockTestimonials: $('.block-testimonials--content'),
      blockInstallatorMobileSlider: $('.agency-menu-mobile > ul'),
      blockInspirations: $('.block-inspirations--content'),
    };

    // Variables
    this.toggleMenu = undefined;
    this.rellax = undefined;
    this.fixer = undefined;
    this.menuMainDesktop = undefined;
    this.menuMainPlaceholder = undefined;
    this.menuMainMobile = undefined;
    this.menuMainDrawer = undefined;
  };

  Theme.all.prototype = {
    init: function () {
      let env =  drupalSettings.env;

      this.initBlockSliderPageProduct();
      this.initMenuMain();
      this.initLazyLoad();
      this.initPageHome();
      this.initPageNew();
      this.initContextualLinks();
      this.initBlockGalery();
      this.initBlockInspirationsWall();
      this.initBlockSlider();
      this.initBlockTestimonials();
      this.initBlockFaq();
      this.initBlockVideo();
      this.initBlockReinssurance();
      this.initBlockProductsCards();
      this.initSliderBrowser();
      this.initSearch();
      this.initBlockInspirations();
      this.initBlockAgencyInfos();
      this.initBlockNewInfos();
      this.initBlockLandingForm();
      this.initSearchAgencies();
      this.initListProduct();
      this.initWebforms();
      this.initWebformMultiStep();
      this.initSlidersForMobile(
        '.view-display-latest-news .view-list--wrapper'
      );
      this.initInstallatorFonctions();
      this.initInstallatorMobileSlider();

      // optional (disabled):
      // this.initEffectsOnScroll();
    },

    load: function () {
      console.log('load');

      this.initSlidersForMobile();
    },
    autoload: function (options) {
      console.log('autoload');
    },

    /**
     * Lazy load
     */
    initLazyLoad: function () {
      var ll = new LazyLoad({
        threshold: 0,
        callback_loaded: function (element) {
          // refresh the gallery block if the image belongs to one
          if (element.closest('.paragraph--type--block-galery')) {
            var all = Drupal.Theme.load('all');
            all.initBlockGalery();
          }
        }
      });
    },
    /**
     * init page home
     */
    initPageHome: function () {
      if ($('.node--type--home').length) {
        // change the display order of blocks in mobile/desktop mode
        function refreshPageHome() {
          if ($(window).outerWidth() < BREAKPOINT_TABLETHOR) {
            let blocProductsCards = $('.field_reference > .paragraph-root.paragraph--type--container-products-cards:first-child');
            if (blocProductsCards.length) {
              if ($('.home-header--presentation-wrapper .paragraph--type--container-products-cards').length <= 0) {
                blocProductsCards.insertAfter($('.home-header--intro'));
              }
            }
            $('.home-header--media').insertAfter($('.home-header--details'));
          }
          else {
            if ($('.field_reference > .paragraph-root.paragraph--type--container-products-cards').length <= 0) {
              $('.field_reference').prepend($('.home-header--presentation-wrapper .paragraph--type--container-products-cards'));
            }
            $('.home-header--media').insertAfter($('.home-header--intro'));
          }
        }
        refreshPageHome();
        $(window).resize(function() {
          refreshPageHome();
        });
      }

    },

    /**
     * Page new
     */
    initPageNew: function () {
      if ($('.node--type--new.node--view-mode--full').length) {
        if ($('.node--type--new.node--view-mode--full .field_other_news .node--type--new.node--view-mode--teaser').length > 1) {
          let othersNews = $('.node--type--new.node--view-mode--full .field_other_news');
          let self = this;
          othersNews.on('translate.owl.carousel', function (event) {
            self.initLazyLoad();
          });
          othersNews.addClass('owl-carousel').owlCarousel({
            loop: true,
            autoplay: false,
            responsiveClass: true,
            autoplayHoverPause: true,
            nav: true,
            navText: [
              '<div class="owl-btn btn-prev"><span class="sr-only">Précédent</span><svg class="icon icon-mobile"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-longue"></use></svg><svg class="icon icon-desktop"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-courte"></use></svg></div>',
              '<div class="owl-btn btn-next"><span class="sr-only">Suivant</span><svg class="icon icon-mobile"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-longue"></use></svg><svg class="icon icon-desktop"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-courte"></use></svg></div>'
            ],
            dots: false,
            autoWidth: false,
            items: 1.1,
            margin: 8,
            center: true,
            responsive: {
              0: {
                items: 1.12,
              },
              768: {
                items: 2.3,
              },
              1024: {
                items: 3.3,
              },
              1200: {
                items: 1.12
              },
            }
          });
        }
      }
    },

    /**
     * Block Menu Main
     */
    initMenuMain: function () {
      if ($('#block-menu-main').length) {
        /** Desktop menu **/
        $('body').on('mouseover touch focus', '#block-menu-main .level0--link', function (e) {
          e.preventDefault();

          var level0Item = $(this).closest('.level0--item');

          if (!level0Item.hasClass('hover')) {
            $(this).closest('.level0').find('.level0--item.hover').removeClass('hover');
            $(this).closest('.level0').find('.level1--item.hover').removeClass('hover');
            level0Item.addClass('hover');
            $('.menu-products-default').show();
          }
        });
        $('body').on('mouseover touch focus', '#block-menu-main .level1--link', function (e) {
          e.preventDefault();

          let level1Item = $(this).closest('.level1--item');

          if (!level1Item.hasClass('hover')) {
            $(this).closest('.level0').find('.level1--item.hover').removeClass('hover');
            $('.menu-products-default').hide();
            level1Item.addClass('hover');

            // fit the menu height to its content
            let level1Height = level1Item.find('.menu-dropdown-1').outerHeight();
            if (level1Height != undefined) {
              $(this).closest('.level1').css('height', level1Height + 'px');
            }
          }
        });
        $('body').on('mouseover touch', function (e) {
          if (!e.target.closest('#block-menu-main')) {
            if ($('#block-menu-main .level0--item.hover').length || $('#block-menu-main .level1--item.hover').length) {
              setTimeout(function () {
                $('#block-menu-main .level0--item').removeClass('hover');
                $('#block-menu-main .level1--item').removeClass('hover');
                $('#block-menu-main .level1').css('height', 'auto');
                $('.menu-products-default').show();
              }, 350);
            }
          }
        });

        /** Mobile menu **/
        let self = this;

        // keep the desktop menu in memory, with a marker to reinsert it at its original place
        self.menuMainDesktop = $('#block-menu-main');
        self.menuMainPlaceholder = document.createComment('menu-main');
        self.menuMainDesktop.after(self.menuMainPlaceholder);

        $('.btn-menu-mobile').on('click touch', function (e) {
          e.preventDefault();

          if (self.menuMainDrawer === undefined) {
            return;
          }
          if (!$(this).hasClass('active')) {
            self.menuMainDrawer.open();
          } else {
            self.menuMainDrawer.close();
          }
          $(this).toggleClass('active');
        });

        // build / remove the mobile menu depending on the mode
        const mqMobile = window.matchMedia('(max-width: ' + (BREAKPOINT_LAPTOP - 1) + 'px)');
        function refreshMenuMain(isMobile) {
          if (isMobile) {
            self.buildMenuMainMobile();
          } else {
            self.destroyMenuMainMobile();
          }
        }
        refreshMenuMain(mqMobile.matches);
        mqMobile.addEventListener('change', function (e) {
          refreshMenuMain(e.matches);
        });

        // create a fixed banner unless it was previously closed
        if ($(window).outerWidth() < BREAKPOINT_TABLET) {
          if (typeof Cookies.get('banner-bottom-mobile') == 'undefined') {
            let pathPage = new URL(document.location.href).pathname;
            // only display the banner on pages not targeted by the banner button
            if (pathPage.indexOf($('#block-menu-shortcuts .btn-quotation').attr('href')) != 0) {
              let btnQuotationBottom = $('#block-menu-shortcuts .btn-quotation').clone().text('Demandez votre devis gratuit');
              $('body').append('<div id="banner-bottom-mobile"></div>');
              $('#banner-bottom-mobile')
                .append(btnQuotationBottom)
                .append('<span class="btn-close"><span class="sr-only">Close</span></span>');
              $('body').css('margin-bottom', $('#banner-bottom-mobile').outerHeight());
              //$('#banner-bottom-mobile .btn-quotation').on('click touch', function (e) {
                // save the closing choice in a cookie
                //Cookies.set('banner-bottom-mobile', 0, {path: '/'});
              //});
              $('#banner-bottom-mobile .btn-close').on('click touch', function (e) {
                e.preventDefault();
                $('#banner-bottom-mobile').hide();
                $('body').css('margin-bottom', '0');

                // save the closing choice in a cookie
                Cookies.set('banner-bottom-mobile', 0, {path: '/'});
              });
            }
          }
        }
      }
    },
    /**
     * Build the mobile menu (and remove the desktop menu)
     */
    buildMenuMainMobile: function () {
      if (this.menuMainMobile !== undefined) {
        return;
      }

      /* build the mobile menu */
      let menuMobile = this.menuMainDesktop.clone().attr('id', 'block-menu-main-mobile');
      menuMobile.find('.hover').removeClass('hover');
      menuMobile.find('.level1').css('height', '');
      $(this.menuMainPlaceholder).after(menuMobile);

      // remove extra spans
      menuMobile.find('.level0--item.parent .level0--link').each(function() {
        $(this).replaceWith($('<span class="level0--link" data-title="' + $(this).text().trim() + '">').append($(this).text().trim()));  // remove link if child menu
      });
      menuMobile.find('.push-first').remove();
      menuMobile.find('.push-second').remove();
      menuMobile.find('.menu-products-default').remove();
      menuMobile.find('.title-children').remove();
      menuMobile.find('.children > .level2').unwrap();
      menuMobile.find('.menu_link_content > ul').unwrap();

      /* move other menus into the mobile menu */
      menuMobile.find('.level0').append($('#block-menu-secondary .level0--item').clone());
      menuMobile.find('.level0').append($('#block-menu-shortcuts .level0--item.with-btn-find').clone());

      this.menuMainMobile = new MmenuLight(
        menuMobile[0],
        "(max-width: " + (BREAKPOINT_LAPTOP - 1) + "px)"
      );
      this.menuMainMobile.navigation({
        theme: 'light',
        selected: 'active'
      });
      this.menuMainDrawer = this.menuMainMobile.offcanvas({
        position: 'left'
      });

      // clone the search form at the top of the menu
      let drawerContent = $(this.menuMainDrawer.content);
      drawerContent.prepend('<div id="site-search-mobile" itemscope="" itemtype="https://schema.org/WebSite"><meta itemprop="url" content="/"></div>');
      drawerContent.find('#site-search-mobile').append($('#search-header-form').clone().attr('id', 'search-header-form-mobile'));

      // detach() keeps jQuery data and events for a later reinsertion
      this.menuMainDesktop.detach();
    },
    /**
     * Remove the mobile menu (and display the desktop menu again)
     */
    destroyMenuMainMobile: function () {
      if (this.menuMainMobile === undefined) {
        return;
      }

      this.menuMainDrawer.close();
      $('.btn-menu-mobile').removeClass('active');

      // MmenuLight has no destroy(): unregister its media query listener and remove its DOM by hand
      this.menuMainMobile.toggler.toggler.removeListener(this.menuMainMobile.toggler.listener);
      $(this.menuMainDrawer.wrapper).remove();
      let orgLocation = this.menuMainPlaceholder.nextSibling;
      if (orgLocation && orgLocation.nodeType === Node.COMMENT_NODE) {
        orgLocation.remove();
      }

      this.menuMainMobile = undefined;
      this.menuMainDrawer = undefined;

      $(this.menuMainPlaceholder).after(this.menuMainDesktop);
    },
    /**
     * Block Gallery
     */
    initBlockGalery: function () {
      var self = this;

      if (self.elements.blockGalery.length) {
        self.elements.blockGalery.each(function () {
          var galeryImages = $(this);
          galeryImages.imagesLoaded( function() {
            galeryImages.masonry({
              // options
              //columnWidth: self.elements.blockGalery.find('.paragraph--type--block-image')[1],
              horizontalOrder: true,
              percentPosition: true
            });
          });
        });
      }
    },

    /**
     * Block InspirationsWall
     */
    initBlockInspirationsWall: function () {
      var self = this;

      if (self.elements.blockInspirationsWall.length) {
        var params = {
          autoplay: false,
          responsiveClass: true,
          autoplayHoverPause: true,
          nav: true,
          navText: [
            '<div class="owl-btn btn-prev"><span class="sr-only">Précédent</span><svg class="icon icon-mobile"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-longue"></use></svg><svg class="icon icon-desktop"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-courte"></use></svg></div>',
            '<div class="owl-btn btn-next"><span class="sr-only">Suivant</span><svg class="icon icon-mobile"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-longue"></use></svg><svg class="icon icon-desktop"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-courte"></use></svg></div>'
          ],
          dots: true,
          autoWidth: true,
          margin: 30,
          responsive: {
            0: {
              //items: 1.3,
              loop: (self.elements.blockInspirationsWall.find('.node--type--inspiration').length > 1),
            },
            768: {
              //items: 2.3,
              loop: (self.elements.blockInspirationsWall.find('.node--type--inspiration').length > 2),
            },
            1024: {
              //items: 3.3,
              loop: (self.elements.blockInspirationsWall.find('.node--type--inspiration').length > 3),
            }
          }
        };

        if ($(window).outerWidth() < BREAKPOINT_LAPTOP) {
          // move the link outside the slider
          self.elements.blockInspirationsWall.find('.block-inspiration-link').insertAfter(self.elements.blockInspirationsWall);
          self.elements.blockInspirationsWall.addClass('owl-carousel').owlCarousel(params);
        }
        $(window).resize(function() {
          if ($(window).outerWidth() < BREAKPOINT_LAPTOP) {
            if (!self.elements.blockInspirationsWall.hasClass('owl-carousel')) {
              // move the link outside the slider
              self.elements.blockInspirationsWall.find('.block-inspiration-link').insertAfter(self.elements.blockInspirationsWall);
              self.elements.blockInspirationsWall.addClass('owl-carousel').owlCarousel(params);
            }
          } else if (self.elements.blockInspirationsWall.hasClass('owl-carousel')) {
            // move the link into the list
            self.elements.blockInspirationsWall.append(self.elements.blockInspirationsWall.closest('.paragraph--type--container-inspirations-wall').find('.block-inspiration-link'));
            self.elements.blockInspirationsWall.trigger('destroy.owl.carousel').removeClass('owl-carousel');
          }
        });

        /*self.elements.blockInspirationsWall.each(function () {
          var galery = $(this);
          //galery.imagesLoaded( function() {
            galery.masonry({
              // options
              //columnWidth: '.grid-sizer',
              itemSelector: '.node--type--inspiration',
              //horizontalOrder: true,
              //percentPosition: true,
              gutter: 30,
            });
          //});
        });*/
      }
    },

    /**
     * Block Slider
     */
    initBlockSlider: function () {
      var self = this;

      if (self.elements.blockSlider.length) {
        self.elements.blockSlider.each(function () {

          // get autoplay parameter
          /*var autoplayTimeout = 0;
          $(this).attr('class').split(' ').forEach(function (item) {
            if (item.indexOf('autoplay-') >= 0) {
              switch (item.replace('autoplay-', '')) {
                case 'slow' :
                  autoplayTimeout = 10000;
                  break;
                case 'fast' :
                  autoplayTimeout = 3000;
                  break;
                case 'normal' :
                  autoplayTimeout = 5000;
                  break;
                default :
                  autoplayTimeout = 0;
              }
            }
          });*/

          // video slide
          $(this).on('click touch', '.link-video-embed.open-here', function (e) {
            e.preventDefault();

            $(this).addClass('hide');

            // stop autoplay on the slider
            if ($(this).closest('.block-slider--content').hasClass('owl-carousel')) {
              $(this).closest('.block-slider--content').trigger('stop.owl.autoplay');
            }

            // play video
            $(this).closest('.paragraph--type--item-slider-slide').find('.content-video-embed').html('<iframe src="' + $(this).attr('href') + '" frameborder="0" allowfullscreen="1" allow="autoplay; fullscreen; encrypted-media"></iframe>');
            $(this).closest('.paragraph--type--item-slider-slide').addClass('play-video');
          });

          var checkLoadingImagesSlider = function(slider) {
            let imagesNotReady = slider.find('img:not([data-image-ready])');
            //console.log('Remaining images to load: ' + imagesNotReady.length);
            if (imagesNotReady.length > 0) {
              imagesNotReady.each(function () {
                // check if the image is loaded
                if ($(this)[0].complete || ($(this)[0].readyState === 4) || ($(this)[0].readyState === 'complete')) {
                  //console.log('Image loaded: ' + $(this)[0].src);
                  $(this).attr('data-image-ready', '1');
                }
                // otherwise force image loading (if not already in progress)
                else if ($(this).attr('data-image-loading') == undefined) {
                  var img = new Image();
                  img.src = $(this)[0].src;
                  $(this).attr('data-image-loading', '1');
                }
              });
            }
            else {
              clearInterval(timerLoadingImages);

              // init slider
              //console.log('Slider init');
              slider.find('.block-slider--content').addClass('owl-carousel').owlCarousel({
                loop: false,
                autoplay: false, //(autoplayTimeout > 0),
                //autoplayTimeout: autoplayTimeout,
                responsiveClass: true,
                //autoplayHoverPause: true,
                nav: slider.hasClass('arrows'),
                navContainer : slider.find('.slider-controls'),
                dotsContainer : slider.find('.slider-controls .slider-dots'),
                navText: [
                  '<div class="owl-btn btn-prev"><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-courte"></use></svg></div>',
                  '<div class="owl-btn btn-next"><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-courte"></use></svg></div>'
                ],
                dots: slider.hasClass('dots'),
                //items: 3,
                margin: 30,
                responsive: {
                  0: {
                    items: 1,
                    autoWidth: false,
                  },
                  768: {
                    items: 2,
                    autoWidth: true,
                  },
                  1024: {
                    items: 3,
                    autoWidth: true,
                  },
                },
                onChange: function (event) {
                  //console.log(event.property.name);
                  // on navigation in a slider paused after a video playback: restart autoplay and stop the video
                  if (event.property.name == 'position') {
                    // restart autoplay
                    /*if ($(event.target).autoplay) {
                      $(event.target).trigger('play.owl.autoplay');
                    }*/

                    // stop video
                    //console.trace($(event.target));
                    $(event.target).find('.paragraph--type--item-slider-slide').removeClass('play-video');
                    $(event.target).find('.paragraph--type--item-slider-slide .content-video-embed').empty();
                    $(event.target).find('.link-video-embed.hide').removeClass('hide');
                  }
                }
              });

            }
          }
          // load images before initializing the slider
          let slider = $(this);
          //console.log('Loading slider images...');
          let timerLoadingImages = setInterval(
            function() {
              checkLoadingImagesSlider(slider);
            }, 150);
        });
      }
    },

    /**
     * Block Testimonials
     */
    initBlockTestimonials: function () {
      var self = this;

      if (self.elements.blockTestimonials.length) {
        self.elements.blockTestimonials.addClass('owl-carousel').owlCarousel({
          loop: true,
          autoplay: true,
          responsiveClass: true,
          autoplayHoverPause: true,
          nav: true,
          navText: [
            '<div class="owl-btn btn-prev"><span class="sr-only">Précédent</span><svg class="icon icon-mobile"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-longue"></use></svg><svg class="icon icon-desktop"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-courte"></use></svg></div>',
            '<div class="owl-btn btn-next"><span class="sr-only">Suivant</span><svg class="icon icon-mobile"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-longue"></use></svg><svg class="icon icon-desktop"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-courte"></use></svg></div>'
          ],
          dots: false,
          autoWidth: false,
          items: 1
        });
      }
    },


    initInstallatorMobileSlider: function () {
      var self = this;

      if (self.elements.blockInstallatorMobileSlider.length) {
        self.elements.blockInstallatorMobileSlider.addClass('owl-carousel').owlCarousel({
          loop: true,
          autoplay: false,
          responsiveClass: true,
          autoplayHoverPause: true,
          nav: true,
          navText: [
            '<div class="owl-btn btn-prev"><span class="sr-only">Précédent</span><svg class="icon icon-mobile"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-longue"></use></svg><svg class="icon icon-desktop"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-courte"></use></svg></div>',
            '<div class="owl-btn btn-next"><span class="sr-only">Suivant</span><svg class="icon icon-mobile"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-longue"></use></svg><svg class="icon icon-desktop"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-courte"></use></svg></div>'
          ],
          dots: false,
          autoWidth: false,
          items: 3
        });
      }
    },

    /**
     * Block Reassurance
     */
    initBlockReinssurance: function () {
      var containerReinssurance = $('.paragraph--type--container-reinssurance .paragraph--row');
      var params = {
        loop: true,
        autoplay: true,
        responsiveClass: true,
        nav: false,
        dots: false,
        autoWidth: false,
        items: 1
      };

      if ($(window).outerWidth() < BREAKPOINT_TABLET) {
        containerReinssurance.addClass('owl-carousel').owlCarousel(params);
      }
      $(window).resize(function() {
        if ($(window).outerWidth() < BREAKPOINT_TABLET) {
          if (!containerReinssurance.hasClass('owl-carousel')) {
            containerReinssurance.addClass('owl-carousel').owlCarousel(params);
          }
        } else {
          if (containerReinssurance.hasClass('owl-carousel')) {
            containerReinssurance.trigger('destroy.owl.carousel').removeClass('owl-carousel');
          }
        }
      });
    },

    /**
     * Block Slider for page product
     */
    initBlockSliderPageProduct: function (el) {
      // thumbnail product
      if ($('.product-header--images').find('.image-product').length > 1) {
        var slideshow = $('.product-header--images .field_images_product');
        var slideshowDotsContainer = '.product-header--images .thumbnail-list';
        $('.product-header--images').append('<div class="thumbnail-list"></div>');
        $('.product-header--images').find('.image-product').each(function (index) {
          $(this).attr('data-id', index + 1);

          var htmlDot = '<div class="thumbnail-item' + (index == 0 ? ' active' : '') + '" data-id="' + index + '">' +
            '<img src="' + $(this).find('img').attr('src') + '" data-src="' + $(this).find('img').data('src') + '" ' +
            'class="' + $(this).find('img').attr('class') + '" alt="Photo ' + (index + 1) + '" />' +
            '<span class="sr-only">Photo ' + (index + 1) + '</span>' +
            '</div>';
          $(this).closest('.product-header--images').find('.thumbnail-list').append(htmlDot);
        });
        $('.thumbnail-list').each(function (index) {
          // more than 4 items: create a second slider
          //if ($(this).find('.thumbnail-item').length > 4) {
          $(this).closest('.thumbnail-list').addClass('owl-carousel').owlCarousel({
            loop: false,
            autoplay: false,
            responsiveClass: true,
            nav: true,
            navText: [
              '<span class="sr-only">Précédent</span><svg class="icon icon-mobile"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-longue"></use></svg><svg class="icon icon-desktop"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-courte"></use></svg>',
              '<span class="sr-only">Suivant</span><svg class="icon icon-mobile"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-longue"></use></svg><svg class="icon icon-desktop"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-courte"></use></svg>'
            ],
            dots: false,
            items: 8,
            margin: 20,
            responsive: {
              0: {
                items: 2,
              },
              576: {
                items: 3,
              },
              768: {
                items: 4,
              },
              1024: {
                items: 3,
              },
              1360: {
                items: 4,
              }
            }
          });

          slideshowDotsContainer = '';
          //}

          $(this).find('.thumbnail-item').on('click touch', function (e) {
            $(this).closest('.product-header--images').find('.thumbnail-item.active').removeClass('active');
            $(this).addClass('active');
            $(this).closest('.product-header--images').find('.field_images_product').trigger('to.owl.carousel', $(this).attr('data-id'));
          });
        });

        // slider
        slideshow.addClass('owl-carousel').owlCarousel({
          loop: true,
          autoplay: false,
          responsiveClass: true,
          nav: false,
          dots: false,
          /*dotsEach: 1,
          dotsContainer: slideshowDotsContainer,*/
          autoplayTimeout: 4000,
          items: 1,
          margin: 10,
        });

        if ($('.thumbnail-list.owl-carousel').length) {
          slideshow.on('changed.owl.carousel', function (event) {
            var slideSelected = $(event.target).find('.owl-item').eq(event.item.index);
            var numSlideSelected = slideSelected.find('.image-product').attr('data-id');
            var objThumbnail = $(event.target).closest('.product-header--images').find('.thumbnail-list.owl-carousel');

            // sync thumbnail if needed
            var majThumbnailSelected = true;
            var objItemsThumbnailSelected = objThumbnail.find(".thumbnail-item[data-id='" + (numSlideSelected - 1) + "']");
            objItemsThumbnailSelected.each(function () {
              if ($(this).hasClass('active')) {
                majThumbnailSelected = false;
              }
            });
            if (majThumbnailSelected) {
              objThumbnail.trigger('to.owl.carousel', numSlideSelected - 1);
              objThumbnail.find('.thumbnail-item.active').removeClass('active');
            }
            // sync the selected item
            objItemsThumbnailSelected.each(function () {
              $(this).addClass('active');
            });
          });
          //slideshow.trigger('to.owl.carousel', 0);    // select the first slide
        }
      }
    },

    /**
     * Block products cards
     */
    initBlockProductsCards: function () {
      $('.paragraph--type--container-products-cards').each(function () {
        let productsCards = $(this).find('.paragraph--row');
        //if (productsCards.find('.paragraph--type--block-product-card').length > 1) {
          productsCards.addClass('owl-carousel').owlCarousel({
            autoplay: false,
            responsiveClass: true,
            autoplayHoverPause: true,
            nav: true,
            navText: [
              '<div class="owl-btn btn-prev"><span class="sr-only">Précédent</span><svg class="icon icon-mobile"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-longue"></use></svg><svg class="icon icon-desktop"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-courte"></use></svg></div>',
              '<div class="owl-btn btn-next"><span class="sr-only">Suivant</span><svg class="icon icon-mobile"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-longue"></use></svg><svg class="icon icon-desktop"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-courte"></use></svg></div>'
            ],
            dots: true,
            autoWidth: true,
            margin: 30,
            responsive: {
              0: {
                //items: 1.2,
                loop: (productsCards.find('.paragraph--type--block-product-card').length > 1),
              },
              768: {
                //items: 2.3,
                loop: (productsCards.find('.paragraph--type--block-product-card').length > 2),
              },
              1024: {
                autoWidth: false,
                items: 3,
                loop: (productsCards.find('.paragraph--type--block-product-card').length > 3),
                rewind: false,
              },
              /*1360: {
                items: 4,
                loop: (productsCards.find('.paragraph--type--block-product-card').length > 4),
              }*/
            }
          });
        //}
      });
    },

    /**
     * Block slider browser
     */
    initSliderBrowser: function () {
      // tabs
      $('body').on('click touch', '.paragraph--type--container-tabs-gallery .field_tab_gallery .tab--link', function (e) {
        console.log(e.cancelable);
        e.preventDefault(true);

        if ($(window).outerWidth() >= BREAKPOINT_TABLETHOR) {
          let currentTab = $(this).attr('href');

          $(this).closest('.field_tab_gallery').find('.tab--link').removeClass('active');
          $(this).closest('.field_tab_gallery').find('.tab--content').removeClass('active');

          $(this).addClass('active');
          $(currentTab).addClass('active');
        }
      });
    },

    /**
     * Init Block Agency Infos
     */
    initBlockAgencyInfos: function() {
      if ($('.page-node-type-agency .agency-header--infos').length || $('.page-node-type-agency-page .agency-header--infos').length) {
        this.refreshBlockAgencyInfos();
        var env =  drupalSettings.env;

        $(window).on('scroll', function () {
          var all = Drupal.Theme.load('all');
          all.refreshBlockAgencyInfos();
        });

        // btn-phone
        $('body').on('click touch', '.agency-header--infos .btn-phone', function (e) {
          if (!$(this).hasClass('active')) {
            e.preventDefault();

            $(this).attr('href', 'tel:' + $(this).data('phone').replaceAll(' ', ''));
            $(this).find('.text').text($(this).data('phone'));
            $(this).addClass('active');
          }
        });

        // call Realytics in PROD only
        // if (env == 'prod') {
          // // quotation request button
          // $('.btn-demander-devis').on('click touch', function (e) {
          //   e.preventDefault();
          //
          //   console.log('Realytics : demande_devis');
          //   RY.track('demande_devis');
          // });

          // appointment button
          /* disabled (tag called on page load; see mantis 26835)
          $('.btn-render-vous').on('click touch', function (e) {
            e.preventDefault();

            console.log('Realytics : prise_rdv');
            RY.track('prise_rdv');
          });*/
        // }
      }
    },

    /**
     * Refresh Agency Infos
     */
    refreshBlockAgencyInfos: function() {
      let blockAgencyInfos = $('.page-node-type-agency .agency-header--infos, .page-node-type-agency-page .agency-header--infos');
      if ($(window).outerWidth() >= BREAKPOINT_LAPTOP) {
        //let blockAgencyContainerWrapperTop = $('.agency-header--infos').offset().top;
        let footerTop = $('.footer-page').offset().top;
        /*let pushImageHeight = $('.push-wrapper .push-contact--image').outerHeight();*/
        //let blockAgencyInfosHeight = $('.push-wrapper .push-contact--content').outerHeight();

        let blockAgencyInfosHeight = $('.agency-header--infos-wrapper').outerHeight();
        let headerSiteHeight = $('.header-site-top').outerHeight();

        if (footerTop - 30 - $(window).scrollTop() >= blockAgencyInfosHeight + 30 + headerSiteHeight) {
          blockAgencyInfos.addClass('sticky');
        }
        else {
          blockAgencyInfos.removeClass('sticky');
        }
      }
      else {
        blockAgencyInfos.removeClass('sticky');
      }
    },

    /**
     * Init Block New Infos
     */
    initBlockNewInfos: function() {
      if ($('.page-node-type-new .new--aside').length || $('.page-node-type-new .new--aside').length) {
        this.refreshBlockNewInfos();

        $(window).on('scroll', function () {
          var all = Drupal.Theme.load('all');
          all.refreshBlockNewInfos();
        });
      }
    },

    /**
     * Refresh New Infos
     */
    refreshBlockNewInfos: function() {
      let blockNewInfos = $('.page-node-type-new .new--aside');

      if ($(window).outerWidth() >= BREAKPOINT_LAPTOP) {
        let footerTop = $('.footer-page').offset().top;
        let blockNewInfosHeight = blockNewInfos.outerHeight();
        let headerSiteHeight = $('.header-site-top').outerHeight();

        if (footerTop - 30 - $(window).scrollTop() >= blockNewInfosHeight + 30 + headerSiteHeight) {
          blockNewInfos.addClass('sticky');
        }
        else {
          blockNewInfos.removeClass('sticky');
        }
      }
      else {
        blockNewInfos.removeClass('sticky');
      }
    },

    /**
     * Init Block Landing form
     */
    initBlockLandingForm: function() {
      if ($('.page-node-type-landing .landing-header--form').length) {
        this.refreshBlockLandingForm();

        $(window).on('scroll', function () {
          var all = Drupal.Theme.load('all');
          all.refreshBlockLandingForm();
        });
      }
    },

    /**
     * Refresh Block Landing form
     */
    refreshBlockLandingForm: function() {
      let blockLandingForm = $('.page-node-type-landing .landing-header--form');
      if ($(window).outerWidth() >= BREAKPOINT_LAPTOP) {
        let footerTop = $('.footer-landing').offset().top;

        let blockLandingFormHeight = $('.landing-header--form-wrapper').outerHeight();
        let headerSiteHeight = $('.header-site-top').outerHeight();

        if (footerTop - 30 - $(window).scrollTop() >= blockLandingFormHeight + 30 + headerSiteHeight) {
          blockLandingForm.addClass('sticky');
        }
        else {
          blockLandingForm.removeClass('sticky');
        }
      }
      else {
        blockLandingForm.removeClass('sticky');
      }
    },

    /**
     * Init Search agencies
     */
    initSearchAgencies: function() {
      if ($('.search-agencies-content').length) {
        let inputSearchAgencies = '.search-agencies-content .form-item-cp input[name=cp]';
        let inputInsee = '.search-agencies-content input[name=insee]';
        let inputCp = '.search-agencies-content input[name=insee]';
        let paramsUrl = new URLSearchParams(window.location.search);
        $(inputCp).attr('autocomplete', 'off');

        // on the search results page: scroll to the results
        if ($(inputSearchAgencies).val() != '' || paramsUrl.get('show') == 'all') {
          var topAnchor = $('#results').offset().top - parseInt($('.header-site--wrapper').outerHeight() + 20);
          $('html, body').stop().animate({scrollTop: topAnchor}, 400);
        }

        $('body').on('click touch', '.search-agencies-content .form-submit', function (e) {
          if ($(inputInsee).val() == '') {
            e.preventDefault();
            $(inputSearchAgencies).select();
            alert('Vous devez saisir et sélectionner un code postal existant');
          }
        });

        $('body').on('keyup focus', inputSearchAgencies, function (e) {
          let charCode = e.which ? e.which : e.keyCode;
          //console.log(charCode);

          //if (charCode >= 96 && charCode <= 105) {
          if (charCode != 13 && !(charCode >= 37 && charCode <= 40)) {
            $(inputInsee).val('');
            let searchVal = $(this).val();

            if (searchVal.length > 2 /*&& !isNaN(parseInt(searchVal))*/) {
              if (!$(inputSearchAgencies).data('autocomplete')) {
                let url = "https://public.opendatasoft.com/api/records/1.0/search/?dataset=laposte_hexasmal&q=" + encodeURIComponent(searchVal) + "&facet=code_postal&sort=code_postal,nom_de_la_commune&rows=1000";
                //let url = "https://datanova.opendatasoft.com/api/records/1.0/search/?dataset=laposte_hexasmal&q=" + encodeURIComponent(searchVal) + "&facet=code_postal&sort=code_postal,nom_de_la_commune&rows=1000";
                //let url = "https://datanova.legroupe.laposte.fr/api/records/1.0/search/?dataset=laposte_hexasmal&q=" + encodeURIComponent(searchVal) + "&facet=code_postal&sort=code_postal,nom_de_la_commune&rows=1000";
                //let url = "https://api-adresse.data.gouv.fr/search/?q=" + encodeURIComponent(searchVal) + "&type=municipality&limit=1000";
                $.getJSON(url, function (results) {
                  console.trace(results);
                })
                  .done(function (results) {
                    let listeResults = results['records'];
                    let listeAutocomplete = [];
                    let valPrec = '';
                    for (let cpt = 0; cpt < listeResults.length; cpt++) {
                      let cp = listeResults[cpt]['fields']['code_postal'].toString();
                      let commune = listeResults[cpt]['fields']['nom_de_la_commune'].toString();
                      let insCode = listeResults[cpt]['fields']['code_commune_insee'].toString();
                      let item = {
                        label: cp + ' ' + commune,
                        value: insCode
                      };
                      if (item.label != valPrec) {
                        valPrec = item.label;
                        //console.log(cp + ' ' + commune);
                        listeAutocomplete.push(item);
                      }
                    }
                    let selectInsCode = function (event, ui) {
                      if (ui.item != null) {
                        //console.log(ui);
                        $(inputInsee).val(ui.item.value);
                        $(e.target).val(ui.item.label);
                        return false;
                      }
                    }
                    $(inputSearchAgencies).autocomplete({
                      delay: 0,
                      minLength: 3,
                      source: listeAutocomplete,
                      select: selectInsCode,
                      change: selectInsCode,
                      focus: selectInsCode,
                    });
                    $(inputSearchAgencies).autocomplete("search");
                  })
                  .fail(function () {
                    alert("Une erreur est survenue");
                  });
              }
            } else {
              if ($(inputSearchAgencies).data('autocomplete')) {
                $(inputSearchAgencies).autocomplete("destroy");
                $(inputSearchAgencies).removeData('autocomplete');
              }
            }
          }
        });

        if ($(window).outerWidth() < BREAKPOINT_TABLET) {
          $(inputSearchAgencies).attr('placeholder', $(inputSearchAgencies).data('placeholder-mobile'));
        }

        $('body').on('click touch', '.btn-geolocation-agencies', function (e) {
          e.preventDefault();

          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
              //console.trace(position);
              let url = "https://nominatim.openstreetmap.org/reverse.php?";
              let data = {
                'lat': position.coords.latitude,
                'lon': position.coords.longitude,
                'format': 'json',
              };
              $.getJSON(url, data, function (results) {
                //console.trace(result);
              })
                .done(function (results) {
                  $(inputSearchAgencies).val(results['address']['postcode']).focus();
                })
                .fail(function () {
                  alert("Une erreur est survenue");
                });
            });
          }
        });
      }
    },

    /**
     * Init List Products
     */
    initListProduct: function() {
      if ($('.list-filtered-products').length) {

        // Filters
        let filtersSelected = false;
        $('.list-filtered-products .views-exposed-form .bef-link--selected').each(function(index) {
          filtersSelected = true;
          let paramUrl = $(this).closest('.form-select').attr('name');
          let urlCurrent = document.location.href;
          let regExpParamUrl = new RegExp("[?&]" + paramUrl + "=([^&]+).*$");

          // To clear a criterion, it must appear in the URL with an empty value
          var urlFilter = '?' + paramUrl + '=';

          // special case: if the param exists, we are not on any list page matching the selected criteria
          // in that case, to clear a criterion it must not appear in the URL
          if (urlCurrent.match(regExpParamUrl) !== null) {
            urlFilter = removeParamFromCurrentUrl(paramUrl);
          }

          /*$('.filters-selected ul').append('<a class="bef-link" href="'+urlFilter+'">'+ $(this).find('span').text() +"</a>");
          $(this).on('click touch', function (e) {
            return false;
          });*/
          $(this).attr('href', urlFilter);
        });
        let countSelection = $('.list-filtered-products .views-exposed-form .form-items-others .bef-link--selected').length;
        if (countSelection > 0) {
          $('.list-filtered-products .views-exposed-form .form-items-others .form-items-others--title > span').append('<span class="count-selection">' + countSelection + '</span>');
        }
        /*if (filtersSelected) {
          $('.form-item-filters-selected').show();
        }*/

        $('body').on('click touch', '.form-items-others--title', function (e) {
          e.preventDefault(true);

          $(this).closest('.form-items-others').toggleClass('unfolded');
        });

        // doors: change the link depending on the resolution
        function refreshBtnProductDoor() {
          $('.node--type--product-door.node--view-mode--teaser').each(function (index) {

            let btnFooter = $(this).find('.teaser--footer .btn--text');

            if ($(this).data('href-mobile') == undefined) {
              $(this).data('href-mobile', $(this).attr('href'));
              btnFooter.data('text-mobile', btnFooter.text());
            }
            if ($(window).outerWidth() >= BREAKPOINT_TABLETHOR) {
              $(this).attr('href', $(this).data('href-desktop'));
              btnFooter.text(btnFooter.data('text-desktop'));
            }
            else {
              $(this).attr('href', $(this).data('href-mobile'));
              btnFooter.text(btnFooter.data('text-mobile'));
            }
          });
        }
        refreshBtnProductDoor();
        $(window).resize(function() {
          refreshBtnProductDoor();
        });

      }
    },


    /**
     * Search bar
     */
    initSearch: function () {
      $('.site-search .form-search').prop('autocomplete', 'off');

      $('body').on('click touch', '.site-header-search .link-search', function (e) {
        e.preventDefault();

        $('.site-header-search ').addClass('active');
        $('.site-search .form-search').focus();
      });
    },


    /**
     * init webforms
     */
    initWebforms: function () {
      // tagging plan
      /*window.addEventListener('load', function () {
        if(drupalSettings.formSubmissionValues) {
          console.log(drupalSettings);
          switch (drupalSettings.formSubmissionName) {
            case 'quotation_light' :
              alert(drupalSettings.formSubmissionName);
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'generate_lead',
                form_name: drupalSettings.formSubmissionTitle,
                user_data: { // in lowercase
                  firstname: drupalSettings.formSubmissionValues.name,
                  lastname: drupalSettings.formSubmissionValues.surname,
                  email: drupalSettings.formSubmissionValues.email,
                  phone: '33601020304', // the number must be preceded by the area code (33 for France)
                  postal_code: drupalSettings.formSubmissionValues.zipcode,
                  country: 'fr'
                }
              });

              break;
            default:
          }
        }
      })*/
    },

    /**
     * init webform multistep
     */
    initWebformMultiStep: function () {
      $('form.multistep:not(.done)').each(function () {
        let form = $(this);
        form.addClass('done');
        form.prepend('<ul class="progress-bar"></ul>');
        $(this).children('fieldset').each(function (index) {
          form.find('.progress-bar').append('<li class="step" data-step="' + (index + 1) + '"></li>');

          if (index == 0) {
            $(this).addClass('active');
          }
          $(this).data('step', index + 1);

          if ($(this).is(':last-of-type')) {
            $(this).closest('form.multistep').find('.form-actions').prepend('<a href="#edit-step' + index + '" class="btn btn-step btn-step-prev">Précédent</a>');
          }
          else {
            let btnGroup = $(this).append('<div class="btn-group no-colors-auto"></div>');
            if (!$(this).is(':first-of-type')) {
              $(this).find('.btn-group').append('<a href="#edit-step' + index + '" class="btn btn-step btn-step-prev">Précédent</a>');
            }
            if (!$(this).is(':last-of-type')) {
              $(this).find('.btn-group').append('<a href="#edit-step' + (index + 2) + '" class="btn btn-step btn-step-next">Suivant</a>');
            }
          }
        });

        $('form.multistep .btn-step').on('click touch', function (e) {
          e.preventDefault();
          e.stopPropagation();

          let stepCurrent = $(this).closest('fieldset').attr('id');
          let numberStepToDisplay = $(this).attr('href').replace('#edit-step', '');
          let stepToDisplay = $(this).closest('form.multistep').find($(this).attr('href'));
          let changeStep = true;
          let fieldOnError = null;

          if (stepToDisplay.length) {
            // check steps
            if ($(this).hasClass('btn-step-next')) {
              // check required fields
              $(this).closest('fieldset').find('input[required]').each(function () {
                switch ($(this).attr('type')) {
                  case 'radio':
                    if (!$(this).closest('fieldset').find('input[name="' + $(this).attr('name') + '"]:checked').length) {
                      changeStep = false;
                      fieldOnError = $(this);
                      return false;
                    }
                    break;
                  default:
                    if ($(this).val() === '') {
                      changeStep = false;
                      fieldOnError = $(this);
                      return false;
                    }
                }
              });
            }

            if (!changeStep) {
              fieldOnError.focus();
              fieldOnError.select();
              alert('Veuillez remplir tous les champs obligatoires');
            }
            else {
              stepToDisplay.addClass('active');

              // progress bar
              for (let i = 1; i <= numberStepToDisplay; i++) {
                form.find('.progress-bar li').eq(i - 1).addClass('active');
              }

              // buttons located on the last step
              if ($(this).parent().hasClass('form-actions')) {
                $(this).parent().removeClass('active');
                $(this).parent().prev('fieldset').removeClass('active');
              } else {
                $(this).closest('fieldset').removeClass('active');
              }
            }
          }

          // display the form submit button
          if (stepToDisplay.next('fieldset').length <= 0) {
            $(this).closest('form.multistep').find('> .form-actions').addClass('active');
          }
          else {
            $(this).closest('form.multistep').find('> .form-actions').removeClass('active');
          }
        });
      });
    },

    /**
     * Blocks Sliders for mobile
     */
    initSlidersForMobile: function (el) {
      var containerBlocks = $(el);
      var params = {
        loop: true,
        autoplay: false,
        responsiveClass: true,
        nav: false,
        dots: false,
        autoWidth: false,
        items: 1.2,
        margin: 25
      };

      if ($(window).outerWidth() < BREAKPOINT_TABLET) {
        containerBlocks.addClass('owl-carousel').owlCarousel(params);
      }
      $(window).resize(function() {
        if ($(window).outerWidth() < BREAKPOINT_TABLET) {
          if (!containerBlocks.hasClass('owl-carousel')) {
            containerBlocks.addClass('owl-carousel').owlCarousel(params);
          }
        } else if (containerBlocks.hasClass('owl-carousel')) {
          containerBlocks.trigger('destroy.owl.carousel').removeClass('owl-carousel');
        }
      });
    },

    /**
     * Block FAQ
     */
    initBlockFaq: function () {
      $('body').on('click touch', '.paragraph--type--block-faq .field_question', function (e) {
        e.preventDefault();
        $(this).addClass('selected');
        $(this).closest('.paragraph--type--block-faq').find('.field_question:not(.selected)').removeClass('active');
        $(this).removeClass('selected').toggleClass('active');
      });
    },

    /**
     * Block video
     */
    initBlockVideo: function () {
      $('body').on('click touch', '.paragraph--type--block-video-embed .block-video-embed--link.open-here', function (e) {
        e.preventDefault();

        $(this).closest('.paragraph--type--block-video-embed').find('.block-video-embed--content').html('<iframe src="' + $(this).attr('href') + '" frameborder="0" allowfullscreen="1" allow="autoplay; fullscreen; encrypted-media"></iframe>');
        $(this).closest('.paragraph--type--block-video-embed').addClass('play');
      });
    },


    /**
     * Block Inspirations
     */
    initBlockInspirations: function () {
      var self = this;

      if (self.elements.blockInspirations.length) {
        let isPageAgency = (self.elements.blockInspirations.closest('.page-node-type-agency').length ? true : false);

        self.elements.blockInspirations.on('translate.owl.carousel', function (event) {
          self.initLazyLoad();
        });
        self.elements.blockInspirations.addClass('owl-carousel').owlCarousel({
          autoplay: true,
          responsiveClass: true,
          autoplayHoverPause: true,
          nav: true,
          navText: [
            '<div class="owl-btn btn-prev"><span class="sr-only">Précédent</span><svg class="icon icon-mobile"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-longue"></use></svg><svg class="icon icon-desktop"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-courte"></use></svg></div>',
            '<div class="owl-btn btn-next"><span class="sr-only">Suivant</span><svg class="icon icon-mobile"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-longue"></use></svg><svg class="icon icon-desktop"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-courte"></use></svg></div>'
          ],
          dots: true,
          autoWidth: true,
          margin: 30,
          responsive : {
            0 : {
              //items: 1.2,
              loop: (self.elements.blockInspirations.find('.paragraph').length > 1),
            },
            1024 : {
              //items: 2.3,
              loop: (self.elements.blockInspirations.find('.paragraph').length > 2),
            },
            1200 : {
              autoWidth: false,
              items: (isPageAgency ? 2 : 3),
              loop: (self.elements.blockInspirations.find('.paragraph').length > (isPageAgency ? 2 : 3)),
              slideBy: 1,
            }
          }
        });
      }
    },

    /**
     * Contextual links
     */
    initContextualLinks: function () {
      // items
      var strContextualLinks = '';
      $('.paragraph-root').each(function (index) {
        if ($(this).attr('id') && $(this).attr('data-label'))
          strContextualLinks += '<li'+ (index == 0 ? ' class="active"' : '') +'><a href="#' + $(this).attr('id') + '" id="contextual-link--' + $(this).attr('id') + '">' + $(this).attr('data-label') + '</a></li>';
      });
      if (strContextualLinks != '') {
        $('.field_reference').prepend('<div class="contextual-menu"><div class="contextual-menu--wrapper"><ul>' + strContextualLinks + '</ul></div></div>');

        //$('.contextual-menu').attr('data-init-offset-top', $('.contextual-menu').offset().top);
        //$('.contextual-menu').attr('data-init-height', $('.contextual-menu--wrapper').outerHeight());

        $('.contextual-menu .contextual-menu--wrapper').on('click touch', function (e) {
          e.preventDefault();

          if ($(window).outerWidth() < BREAKPOINT_TABLET) {
            $(this).closest('.contextual-menu').toggleClass('collapsed');
          }
        });
        $('.contextual-menu .contextual-menu--wrapper a').on('click touch', function (e) {
          e.stopPropagation();

          if (!$(this).closest('li').hasClass('active')) {
            var target = $(this).attr('href');
            //var topAnchor = $(target).offset().top - parseInt($('.header-site').outerHeight()) - parseInt($('.contextual-menu').attr('data-init-height'));
            var topAnchor = $(target).offset().top - parseInt($('.header-site--wrapper').outerHeight()) - parseInt($('.contextual-menu--wrapper').outerHeight());
            //var topAnchor = $(target).offset().top - parseInt($('.contextual-menu--wrapper').outerHeight());

            $('html, body').stop().animate({scrollTop: topAnchor}, 400);
          }
        });

        // refresh
        this.refreshContextualLinks();

        $(window).on('scroll', function () {
          var all = Drupal.Theme.load('all');
          all.refreshContextualLinks();
        });
      }
    },

    /**
     * refreshContextualLinks
     */
    refreshContextualLinks: function () {
      var all = Drupal.Theme.load('all');
      var menuContextualTop = $('.contextual-menu').offset().top; //$('.contextual-menu').attr('data-init-offset-top');
      var menuContextualHeight = $('.contextual-menu--wrapper').outerHeight(); //$('.contextual-menu').attr('data-init-height');

      // items
      /*console.log($(window).scrollTop() + '+' + $('.header-site').outerHeight());
      console.log($('.contextual-menu').offset().top);
      console.log(($(window).scrollTop() + $('.header-site').outerHeight()) +'>='+ menuContextualTop);*/

      if (($(window).scrollTop() + $('.header-site--wrapper').outerHeight()) >= menuContextualTop) {
        //if ($(window).scrollTop() >= menuContextualTop) {
        $('.contextual-menu').css('height', menuContextualHeight);
        $('.contextual-menu--wrapper').css('top', $('.header-site--wrapper').outerHeight());
        //$('.contextual-menu--wrapper').css('top', '0');
        $('body').addClass('contextual-menu-sticky');
      }
      else {
        $('.contextual-menu').css('height', 'auto');
        $('.contextual-menu--wrapper').css('top', 'auto');
        $('body').removeClass('contextual-menu-sticky');
      }

      //var deltaTop = parseInt($('.header-site--wrapper').outerHeight()) + parseInt($('.contextual-menu').attr('data-init-height'));
      var deltaTop = parseInt($('.header-site--wrapper').outerHeight()) + parseInt($('.contextual-menu--wrapper').outerHeight());
      var deltaTop = parseInt($('.contextual-menu--wrapper').outerHeight());
      var activeLink = "";
      var links = $('.contextual-menu .contextual-menu--wrapper a').get().reverse();
      $(links).each(function () {
        var idLink = '#' + $(this).attr('id');
        var paragRoot = $(idLink.replace('contextual-link--', '')).closest('.paragraph-root');

        if (all.isScrolledIntoView(paragRoot, deltaTop)) {
          activeLink = idLink;
        }
      });

      if (activeLink != "") {
        $('.contextual-menu .contextual-menu--wrapper li.active').removeClass('active');
        $(activeLink).closest('li').addClass('active');
      }
    },

    /**
     * isScrolledIntoView
     */
    isScrolledIntoView: function (elem, deltaTop){
      var win = $(window);
      var viewport = {
        top : win.scrollTop() + deltaTop,
        left : win.scrollLeft()
      };
      viewport.right = viewport.left + win.width();
      viewport.bottom = viewport.top + win.height() - deltaTop;

      var bounds = elem.offset();
      bounds.right = bounds.left + elem.outerWidth();
      bounds.bottom = bounds.top + elem.outerHeight();

      //var deltaTop = parseInt($('.header-site--wrapper').outerHeight()) + parseInt($('.contextual-menu').attr('data-init-height'));
      //var deltaTop = parseInt($('.header-site--wrapper').outerHeight()) + parseInt($('.contextual-menu--wrapper').outerHeight());
      var deltaTop = parseInt($('.contextual-menu--wrapper').outerHeight());

      /*console.log(elem.prop('id'));
      console.log('top:' + viewport.top +'>'+ bounds.bottom);
      console.log('bottom:' + viewport.bottom +'<'+ bounds.top);*/

      return (!(
        viewport.right < bounds.left ||
        viewport.left > bounds.right ||
        viewport.bottom < bounds.top + (win.height()/4) ||
        viewport.top + deltaTop > bounds.bottom
      ));
    },

    initInstallatorFonctions: function() {
      if($('.agency-menu').length !== 0) {
        // Scroll Sticky Nav
        $(window).scroll(function() {
          if(($(this).scrollTop() - $('.header-site-top').innerHeight()) >= ($('.agency-menu').offset().top - 80)) {
            if($('.agency-menu.sticky').length === 0) {
              $('.agency-menu').clone().appendTo(".node--type--agency-page.node--view-mode--full").addClass('sticky hide');
              $('.agency-menu').clone().appendTo(".node--type--agency.node--view-mode--full").addClass('sticky hide');
              $('.agency-menu.sticky > ul > li.has-children > a').click(function(e) {
                if($(window).width() < 1000) e.preventDefault();
              });
              $('.agency-menu.sticky > ul > li.has-children').click(clickOnMenuInstallator);
              $('.agency-menu.sticky .menu').scroll(function() {
                $('.agency-menu > .arrow').fadeOut(100);
              });
              $('.agency-menu.sticky .submenu ul').scroll(function() {
                $('.agency-menu .submenu .arrow').fadeOut(100);
              });
            }else {
              $('.agency-menu.sticky').removeClass('hide');
            }
          }else {
            $('.agency-menu.sticky').addClass('hide');
          }
        });

        $('.agency-menu > ul > li.has-children > a').click(function(e) {
          if($(window).width() < 1000) e.preventDefault();
        });
        $('.agency-menu > ul > li.has-children').click(clickOnMenuInstallator);

        if($(window).width() < 1000) {
          if($('.agency-menu > ul')[0].scrollWidth > $('.agency-menu').innerWidth()) {
            $('.agency-menu > .arrow:not(.hide)').show();
          }
          $('.agency-menu > ul > li .submenu > ul').each(function() {
            if($(this)[0].scrollWidth > $(this).parent().innerWidth()) {
              $(this).parent().find('.arrow:not(.hide)').show();
            }
          });
        }

        $(window).resize(function() {
          if($('.agency-menu > ul')[0].scrollWidth > $('.agency-menu').innerWidth()) {
            $('.agency-menu > .arrow:not(.hide)').show();
          }else {
            $('.agency-menu > .arrow:not(.hide)').hide();
          }
          $('.agency-menu > ul > li .submenu > ul').each(function() {
            if($(this)[0].scrollWidth > $(this).parent().innerWidth()) {
              $(this).parent().find('.arrow:not(.hide)').show();
            }else {
              $(this).parent().find('.arrow:not(.hide)').hide();
            }
          });
        });

        $('.agency-menu .menu').scroll(function() {
          $('.agency-menu > .arrow').fadeOut(100);
          $('.agency-menu > .arrow').addClass('hide');
        });

        $('.agency-menu .submenu ul').scroll(function() {
          $('.agency-menu .submenu .arrow').fadeOut(100);
          $('.agency-menu .submenu .arrow').addClass('hide');
        });
      }
    }

    /**
     * initEffectsOnScroll (optional)
     * Requires scrollreveal: enable it in site.json ("./node_modules/scrollreveal/dist/scrollreveal.min.js")
     */
    /*initEffectsOnScroll: function (){
      var optionReset = false;
      var optionDelay = 200;
      var options;
      var delai;

      // titles animation
      options = { reset: optionReset, delay: 0, duration: 800, distance: '50px', origin: 'left', opacity: 0, interval: 150 };
      ScrollReveal().reveal(
          '.effects-enabled .content-page-header--wrapper .title1, ' +
          '.effects-enabled .content-page-header--wrapper .field_header_text',
          options
      );
      options = { reset: optionReset, delay: optionDelay, duration: 800, origin: 'bottom', opacity: 0 };
      ScrollReveal().reveal('.effects-enabled .paragraph--type--item-container-header', options);

      // numbers animation
      options = {reset: optionReset, delay: 0, duration: 600, origin: 'bottom', opacity: 0,
          afterReveal: function (el) {
              var all = Drupal.Theme.load('all');
              all.animateNumber($(el));
          }
      };
      ScrollReveal().reveal('.effects-enabled .wysiwyg .numerator', options);

      // footer social network icons animation
      options = {reset: optionReset, delay: optionDelay, duration: 1000, origin: 'bottom', opacity: 0, scale: 1.5 };
      ScrollReveal().reveal($('.effects-enabled').closest('body').find('#block-menu-social-media .level0--item'), options);

      // animation of cards inside views
      options = { reset: optionReset, delay: optionDelay, duration: 600, origin: 'bottom', opacity: 0, scale: 0.5, interval: 200 };
      ScrollReveal().reveal($('.effects-enabled .views-element-container .view-list--wrapper > .view-item'), options);

      // FAQ questions animation
      options = { reset: optionReset, delay: optionDelay, duration: 800, origin: 'right', opacity: 0, interval: 200 };
      ScrollReveal().reveal($('.effects-enabled .paragraph--type--block-faq .field_question'), options);

      // buttons animation
      options = { reset: optionReset, delay: optionDelay, duration: 600, origin: 'bottom', opacity: 0, scale: 0.5, interval: 100 };
      ScrollReveal().reveal($('.effects-enabled .paragraph-root .btn, .paragraph-root .button'), options);

      // quote paragraph animation
      options = { reset: optionReset, delay: optionDelay, duration: 800, origin: 'bottom', opacity: 0, scale: 1.5, interval: 200 };
      ScrollReveal().reveal(
          $('.effects-enabled .paragraph--type--block-citation .field_sentence'),
          options
      );
      options = { reset: optionReset, delay: optionDelay, duration: 800, origin: 'bottom', opacity: 0, scale: 0.5, interval: 200 };
      ScrollReveal().reveal(
          $('.effects-enabled .paragraph--type--block-citation .field_author, ' +
              '.effects-enabled .paragraph--type--block-citation .field_author_title'),
          options
      );

      // alternating animation of root paragraphs
      var cptParagraphRoot = 0;
      $('.effects-enabled .paragraph-root').each(function (index) {

          // animation for "2 columns" paragraphs
          if ($(this).hasClass('paragraph--type--container-2col') ||
              $(this).hasClass('paragraph--type--container-2wysiwyg') ||
              $(this).hasClass('paragraph--type--container-faq') ||
              $(this).hasClass('paragraph--type--container-image-text') ||
              $(this).hasClass('paragraph--type--container-video-text')) {

              // sub-paragraphs
              $(this).find('.paragraph--row > *').each(function (index) {
                  if ($(this).closest('.paragraph-root').hasClass('display-rtl')) {
                      var origin = (index % 2 == 0 ? 'right' : 'left');
                  }
                  else {
                      var origin = (index % 2 == 0 ? 'left' : 'right');
                  }
                  options = { reset: optionReset, delay: optionDelay, duration: 800, distance: '200px', origin: origin, opacity: 0 };
                  ScrollReveal().reveal($(this), options);
              });
          }
          // animation for paragraphs containing cards
          else if ($(this).hasClass('paragraph--type--container-3col') ||
              $(this).hasClass('paragraph--type--container-4col') ||
              $(this).hasClass('paragraph--type--container-reinssurance') ||
              $(this).hasClass('paragraph--type--container-content-custom')) {
              options = { reset: optionReset, delay: optionDelay, duration: 600, origin: 'bottom', opacity: 0, scale: 0.5, interval: 200 };
              ScrollReveal().reveal($(this).find('.paragraph--row .paragraph--type--block-card'), options);
          }

          // timeline paragraph animation
          else if ($(this).hasClass('paragraph--type--container-chronology')) {
              // sub-paragraphs
              $(this).find('.chronology--item-text').each(function (index) {
                  var origin = (index % 2 == 0 ? 'left' : 'right');
                  options = { reset: optionReset, delay: optionDelay, duration: 800, distance: '200px', origin: origin, opacity: 0 };
                  ScrollReveal().reveal($(this), options);
              });
          }

          // gallery paragraph animation
          else if ($(this).hasClass('paragraph--type--container-galery')) {
              options = { reset: optionReset, delay: optionDelay, duration: 600, origin: 'bottom', opacity: 0, scale: 0.5, interval: 200 };
              ScrollReveal().reveal($(this).find('.paragraph--type--block-image'), options);
          }
          // animations for "multiline" paragraphs
          else if ($(this).hasClass('paragraph--type--container-col2-texts')) {
              cptParagraphRoot++;

              // sub-paragraphs
              $(this).find('.container-col2-texts--content > li').each(function (index) {
                  var origin = (index % 2 == 0 ? 'right' : 'left');
                  options = { reset: optionReset, delay: optionDelay, duration: 800, distance: '200px', origin: origin, opacity: 0 };
                  ScrollReveal().reveal($(this), options);
              });
          }
          // animation for other paragraphs
          else if (!$(this).hasClass('paragraph--type--container-wysiwyg') &&
              !$(this).hasClass('paragraph--type--container-citation') &&
              !$(this).hasClass('paragraph--type--container-webform')) {
              cptParagraphRoot++;

              var origin = (index % 2 == 0 ? 'right' : 'left');
              options = { reset: optionReset, delay: optionDelay, duration: 800, distance: '200px', origin: origin, opacity: 0 };
              ScrollReveal().reveal($(this), options);
          }
      });
    },*/
  };

  function clickOnMenuInstallator() {
    if($(window).width() < 1000) {
      if($(this).hasClass('open')) {
        $(this).parent().removeClass('showSubNavMobile');
        $(this).find('.submenu').removeClass('open');
        $(this).removeClass('open');
      }else {
        $('.agency-menu .submenu').removeClass('open');
        $(this).parent().addClass('showSubNavMobile');
        $(this).find('.submenu').addClass('open');
        $(this).addClass('open');
      }
    }
  }

}(jQuery, Drupal, drupalSettings));

function removeParamFromCurrentUrl(sParam) {
  var url = window.location.href.split('?')[0]+'?';
  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] != sParam) {
      url = url + sParameterName[0] + '=' + sParameterName[1] + '&'
    }
  }
  return url.substring(0,url.length-1);
}
